import { render } from "./SpeechSynthesis.vue?vue&type=template&id=03558cb4&scoped=true"
import script from "./SpeechSynthesis.vue?vue&type=script&lang=js"
export * from "./SpeechSynthesis.vue?vue&type=script&lang=js"

import "./SpeechSynthesis.vue?vue&type=style&index=0&id=03558cb4&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03558cb4"]])

export default __exports__